import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Row, Col, Button, Container } from "react-bootstrap";
import axios from "axios";
import { selectUser } from "../../features/userSlice"; // Adjust based on your Redux setup
import "./Dashboard.css"; // Custom CSS for the dashboard

const Dashboard = () => {
  const [menuOptions, setMenuOptions] = useState([]);
  const user = useSelector(selectUser); // Get user info from Redux
  const emp_id = user?.emp_id;
  const token = user?.token;
  const navigate = useNavigate();

  useEffect(() => {
    if (token && emp_id) {
      const fetchMenuOptions = async () => {
        try {
          const menuResponse = await axios.post("/api/menu/getMenuUserData", { emp_id });
          console.log("menuresponse:", menuResponse);
          // Filter and organize the menu options
          const parentMenus = menuResponse.data.filter(menu => menu.PARENT_MENU_ID === null);
          const childMenus = menuResponse.data.filter(menu => menu.PARENT_MENU_ID !== 0);

          const groupedMenuOptions = parentMenus.map(parent => ({
            ...parent,
            children: childMenus.filter(child => child.PARENT_MENU_ID === parent.MENU_ID)
          }));
          
          setMenuOptions(groupedMenuOptions); // Store the organized menu
        } catch (error) {
          console.log("Error fetching menu options:", error);
        }
      };

      fetchMenuOptions();
    } else {
      navigate("/login"); // Redirect to login if not authenticated
    }
  }, [token, emp_id, navigate]);

  const handleTileClick = (menuUrl) => {
    if (menuUrl) {
      console.log("Navigating to:", menuUrl);
      navigate(menuUrl);
    } else {
      console.error("No URL for this menu item.");
    }
  };

  return (
    <div className="dashboard-container">
      <Container fluid> {/* Changed to fluid to utilize more space */}
        <h1 className="dashboard-title">Welcome to Your SEPL EXTENDED ERP</h1> {/* Updated title */}
        
        {/* Loop through each parent menu */}
        {menuOptions.map((parentMenu, index) => (
          parentMenu.MENU_URL ? (
            <Row key={index} className="mb-3">
              <Col xs={6} sm={4} md={3} lg={2}> {/* Adjusted column size */}
                <Button
                  variant="outline-primary"
                  className="menu-tile-btn"
                  block
                  onClick={() => handleTileClick(parentMenu.MENU_URL)} // Handle tile click
                  style={{ textTransform: 'capitalize', fontSize: '0.8rem' }}
                >
                  {parentMenu.MENU_NAME}
                </Button>
              </Col>
            </Row>
          ) : (
            <div key={index} className="menu-section">
              <h2 className="section-title">{parentMenu.MENU_NAME}</h2>
              <Row>
                {parentMenu.children.map((childMenu, childIndex) => (
                  <Col key={childIndex} xs={6} sm={4} md={3} lg={2} className="mb-3"> {/* Adjusted column size */}
                    <Button
                      variant="outline-primary"
                      className="menu-tile-btn"
                      block
                      onClick={() => handleTileClick(childMenu.MENU_URL)} // Handle child tile click
                      //style={{ textTransform: 'capitalize', fontSize: '0.8rem' }}
                    >
                      {childMenu.MENU_NAME}
                    </Button>
                  </Col>
                ))}
              </Row>
            </div>
          )
        ))}
      </Container>
    </div>
  );
};

export default Dashboard;
